/**
 * Portal detection utilities
 * Shared logic for determining if we're in internal portal mode
 */

/**
 * Check if we're on the internal portal
 * SECURITY: Validates actual hostname to prevent manipulation via URL params
 *
 * @returns true if on internal portal domain or localhost with internal flag
 */
export function isInternalPortalMode(): boolean {
  const hostname = window.location.hostname;

  // Production/staging internal domains
  const isInternalDomain =
    hostname === 'internal.admin.latteconnect.app' ||
    hostname === 'internal.beta.latteconnect.app';

  // Local development with internal flag (URL param is sufficient)
  const isLocalWithInternalFlag =
    hostname === 'localhost' &&
    window.location.search.includes('internal=true');

  return isInternalDomain || isLocalWithInternalFlag;
}
